// import { canUseDOM } from 'exenv';

export function companyIndexSectionLoading(resp = {}, store = {}) {
  return {
    type: 'COMPANY_INDEX_SECTION_LOADING',
    companyIndexSection: resp,
    store
  };
}

export function companyIndexSectionLoaded(resp = {}, store = {}) {
  return {
    type: 'COMPANY_INDEX_SECTION_LOADED',
    companyIndexSection: resp,
    store
  };
}

export function companyIndexSectionLoadError(error, store = {}) {
  return {
    type: 'COMPANY_INDEX_SECTION_ERROR',
    companyIndexSection: {
      isLoading: false,
      error: true,
      errorMessage: error ? error.message : 'no message'
    },
    store
  };
}
